import React from 'react';
import { useAppSelector } from '../../app/hooks';
import { Role } from '../../common/constants';

type DisplayForProps = {
  roles?: Role[];
  exceptRoles?: Role[];
  children: JSX.Element;
  allowOnEmpty?: boolean;
};

export const IsAllowedComponent = (roles?: Role[], exceptRoles?: Role[], allowOnEmpty: boolean = false, givenRoles?: Role[]): boolean => {
  const userRoles = useAppSelector((s) => s.user.roles);

  if (!roles) return allowOnEmpty;

  let exceptRoleIsPresent = exceptRoles?.some(role => {
    return userRoles?.includes(role.toString());
  });

  if (exceptRoleIsPresent)
    return false;

  return userRoles?.includes(Role.SuperUser.toString()) || roles.some((role) => {
    return userRoles?.includes(role.toString());
  });
};

export const IsAllowed = (roles?: Role[], allowOnEmpty: boolean = false, userRoles?: string | string[], exceptRoles?: Role[]): boolean => {
  if (!roles || !userRoles) return allowOnEmpty;

  return userRoles?.includes(Role.SuperUser.toString()) || roles.some((role) => {
    return userRoles?.includes(role.toString());
  });
};

export const IsAllowedExcept = (roles?: Role[], userRoles?: string | string[]): boolean => {
  return userRoles?.includes(Role.SuperUser.toString()) || !roles?.some(role => {
    return userRoles?.includes(role.toString());
  });
};

const DisplayFor = ({
  roles,
  exceptRoles,
  children,
  allowOnEmpty = false,
}: DisplayForProps): JSX.Element => {
  let allow = IsAllowedComponent(roles, exceptRoles, allowOnEmpty);
  return allow ? children : <React.Fragment />;
};

export default DisplayFor;
